import PostbackActions from '../../../../actions/PostbackActions';
import GoalActions from '../../../../actions/GoalActions';
import store from '../../../../stores/redux';

export const actions = {
    getListPostbacks(params = {}) {
        PostbackActions.getListPostbacks({
            page: params.page
        }, () => {
            const ids = _getListIdsGoalActions()
            const params = {
                ids: ids.join(','),
                fields: 'goal_action.goal,goal.offer',
                count: ids.length
            };
            GoalActions.getListGoalActions(params);
        });
    },

    getListGoalActionsByIds(ids) {
        let list = [];
        const goalActions = store.getState().goalActions.list;

        if (goalActions.length) {
            ids.map((id) => {
                list.push(goalActions.find((item) => item.id === id) || id);
            });
        }

        return list;
    },

    onDeletePostback(state) {
        PostbackActions.deletePostback({
            id: state.deletePostbackId
        }, () => {
            this.getListPostbacks({page: state.page});
        });
    }
};

const _getListIdsGoalActions = () => {
    let ids = [];
    const postbacks = store.getState().postbacks.list.data;

    postbacks.map((item) => {
        const goalActionsIds = item.config.goal_action_ids;

        if (goalActionsIds && goalActionsIds.length) {
            ids = ids.concat(goalActionsIds);
        }
    });

    return ids;
};
